import React, { useEffect } from "react";
import BreadCrumbsBar from "../BreadCrumbsBar/BreadCrumbsBar";
import Footer from "./Footer/Footer";
import NavBar from "./NavBar/NavBar";
import {
  findKitchenTypologiesWithTotalItem,
} from "../../services/kitchenTypologyService";
import { useDispatch, useSelector } from "react-redux";
import {
  setKitchenTypologies,
} from "../../redux/kitchenTypologiesSlice";
import { findStructureCategoriesWithTotalItem } from "../../services/structureCategoryService";
import { setStructureCategories } from "../../redux/structureCategoriesSlice";
import { initialize } from "../../redux/initSlice";
import LinkButton from "../LinkButton/LinkButton";
import { ROUTES } from "../../config/site.config";

const MainLayout = (props) => {
  const dispatch = useDispatch();
  const _init = useSelector((state) => state.init.value);

  const {
    breadcrumbs,
    breadcrumbsRight,
    breadCrumbsTitle,
    breadCrumbsSubTitle,
  } = props;

  const fetchData = async () => {
    let [
      kitchenTypologiesRes,
      structureCategoriesRes,
    ] = await Promise.all([
      findKitchenTypologiesWithTotalItem(),
      findStructureCategoriesWithTotalItem(),
    ]);

    dispatch(setKitchenTypologies(kitchenTypologiesRes.data.contentData));
    dispatch(setStructureCategories(structureCategoriesRes.data.contentData));
    dispatch(initialize());
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    !_init && fetchData();
  }, []);

  return (
    <div>
      <NavBar
        breadcrumbs={breadcrumbs}
        linkColor={props.linkColor}
        style={{ position: breadcrumbs ? "relative" : "fixed", zIndex: 3 }}
        accessoryRight={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LinkButton label="Aderisci" to={ROUTES.JOIN_PATH} buttonStyle={{width: 100}}/>
            <LinkButton label="Suggerisci" to={ROUTES.SUGGEST_PATH} buttonStyle={{width: 100}}/>
          </div>
        }
      />
      {breadcrumbs && (
        <BreadCrumbsBar
          breadCrumbsTitle={breadCrumbsTitle}
          breadcrumbsRight={breadcrumbsRight}
          breadCrumbsSubTitle={breadCrumbsSubTitle}
        />
      )}

      <div
        style={{
          position: "relative",
          flex: 1,
          marginTop: breadcrumbs ? 0 : 70,
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          ...props.contentStyle,
        }}
      >
        {props.children}
      </div>
      <Footer style={{ position: "relative", bottom: "0" }} />
    </div>
  );
};

export default MainLayout;
